import jsSHA from "jssha";
import moment from 'moment-timezone';

const SEED = "3132333435363738393031323334353637383930";

const DIGITS_POWER = [
  1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000,
];

function hmac(keyBytes, text) {
  let shaObj = new jsSHA("SHA-1", "HEX");
  shaObj.setHMACKey(keyBytes, "HEX");
  shaObj.update(text);
  let hmac = shaObj.getHMAC("UINT8ARRAY");
  return hmac;
}

function generateTOTP(key, time, codeDigits) {
  while (time.length < 16) time = "0" + time;

  let hash = hmac(key, time);

  let offset = hash[hash.length - 1] & 0xf;

  let binary =
    ((hash[offset] & 0x7f) << 24) |
    ((hash[offset + 1] & 0xff) << 16) |
    ((hash[offset + 2] & 0xff) << 8) |
    (hash[offset + 3] & 0xff);

  let otp = binary % DIGITS_POWER[codeDigits];

  let result = otp.toString();
  while (result.length < codeDigits) {
    result = "0" + result;
  }

  return result;
}

export function getCurrentTOTP(dataHoraInicioStr) {
  const t0 = 0;
  const interval = 20000;
  let data = new Date(dataHoraInicioStr);
  let dt = moment(data).tz("America/Sao_Paulo", true);
  let t = dt.valueOf();
  let timestamp = (t - t0) / interval;
  let hexString = timestamp.toString(16).toUpperCase();
  if (hexString.includes(".")) {
    hexString = hexString.substring(0, hexString.indexOf("."));
  }
  return generateTOTP(SEED, hexString, 8);
}